import React, { FC } from "react";
import { Row, Col, Card, Progress } from "antd";
import "./progress-card.scss";

const ProgressCard: FC<any> = (props) => {
  return (
    <Col span={props.size} style={props?.style}>
      <Card style={{ height: props.cardHeight }} className="progress-card">
        <Row>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              height: props.cardHeight / 3,
            }}
            span={24}
          >
            {props.name}
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "center",
              height: (props.cardHeight * 2) / 3,
            }}
            span={24}
          >
            <Progress
              type="circle"
              percent={props?.value ? props.value : 0}
              strokeColor={props.color}
              format={(percent)=> { return `${percent} %` }}
              status="normal"
            />
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default ProgressCard;
